import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { LoadingButton } from '@mui/lab';
import SaveIcon from '@mui/icons-material/Save';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const [testTypeLabel, setTestTypeLabel] = React.useState("Test");
  const [delTestLoading, setDelTestLoading] = React.useState(false);
  const [continueTestLoading, setContinueTestLoading] = React.useState(false);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  React.useEffect(() => {
    if(open && props.testType==1){
      setTestTypeLabel("Session");
    }else{
      setTestTypeLabel("Test");
    }
	}, [open,props.testType]);

  function deleteCurrentStart(){  
    //setOpen(false);      
    setDelTestLoading(true);
    props.toCallDeleteCurrentStartNew();      
  }

  function continueCurrent(){  
    ///setOpen(false);  
    setContinueTestLoading(true);
    props.toCallContinueCurrentTest();      
  }
  
  return (
    <>
      <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-32px'}} onClose={handleClose}></DialogTitle>
        <DialogContent dividers>
            <div className="dialogSubmitTestBox">
              <div className="btmbdrgry" style={{color:'#fe3000'}}><h3>Warning !</h3></div>              
              <p style={{margin:40, textAlign:'center', fontWeight:'bold',color:'#fe3000'}} >
              <span style={{color:'#0000FF',fontSize:14}}>{props.currentRunningTestTitle}</span><br/>  
              We have found incomplete {testTypeLabel} in our records.
              </p>
              {delTestLoading?
                <LoadingButton loading={delTestLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#fe3000',color:'#FFFFFF',marginBottom:5}} variant="contained" >Deleting...</LoadingButton>
                :<Button onClick={() => {deleteCurrentStart()}} variant="contained" style={{backgroundColor:'#fe3000',color:'#FFFFFF',marginBottom:5}} >Delete & Start New {window.screen.width>480?testTypeLabel:null}</Button>
              }
              {continueTestLoading?
                <LoadingButton loading={continueTestLoading} loadingPosition="start" startIcon={<SaveIcon />} style={{backgroundColor:'#3baa6a',color:'#FFFFFF',marginBottom:5}} variant="contained" >Wait...</LoadingButton>
                :<Button onClick={() => {continueCurrent()}} variant="contained" style={{backgroundColor:'#3baa6a',color:'#FFFFFF',marginBottom:5}} >Continue with Incomplete {window.screen.width>480?testTypeLabel:null}</Button>
              }
              {window.screen.width>480?
                <Button onClick={() => {handleClose()}} style={{marginRight:20,marginBottom:5}} size="small" variant="outlined" >Cancel</Button>
              :null}  
            </div>
        </DialogContent>

      </Dialog>
    </>
  );

});

export default CustomizedDialogs;